// extracted by mini-css-extract-plugin
export default {"btn":"index_btn__uJGll","text":"index_text__sohj8","error":"index_error__3NqVN","warn":"index_warn__ftjs3","txt":"index_txt__NOhUE"};